import { create } from 'xmlbuilder2'
import { SDO } from '/@/shared/entities/SDO'
import { Dir } from '/@/shared/entities/Dir'
import { createSDOElement } from './helpers'

class Sdo {
  private readonly sdos: SDO[]
  private readonly dir: Dir
  private readonly pretty: boolean

  constructor(sdos: SDO[], dir: Dir, pretty: boolean = true) {
    this.sdos = sdos
    this.dir = dir
    this.pretty = pretty
  }

  public toXML() {
    const root = create().ele('EtherCATSdos')

    this.sdos.forEach((sdo) => createSDOElement(root, Dir.sdoTag(this.dir), sdo))

    return root.end({ prettyPrint: this.pretty })
  }
}

export default Sdo
